import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "MapParty" }
const _hoisted_2 = { class: "MapParty__party" }

import { PropType } from "vue";
import { Party } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'MapParty',
  props: {
    party: {
        type: Object as PropType<Party>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "MapParty__color",
      style: _normalizeStyle({ backgroundColor: __props.party.color })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.party.name), 1)
  ]))
}
}

})